export const GoogleMapsAPI = 'AIzaSyBUjxSZktZ4NVD4SkKs2a1gVuV3dA78RC0';
